// extracted by mini-css-extract-plugin
module.exports = {"container":"TabContainer_container__15hwO"};